var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFolder2 = function SvgFolder2(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "currentColor",
    fillOpacity: 0.06
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 16C12.5 15.4696 12.7107 14.9609 13.0858 14.5858C13.4609 14.2107 13.9696 14 14.5 14H19.5L21.5 16H26.5C27.0304 16 27.5391 16.2107 27.9142 16.5858C28.2893 16.9609 28.5 17.4696 28.5 18V24C28.5 24.5304 28.2893 25.0391 27.9142 25.4142C27.5391 25.7893 27.0304 26 26.5 26H14.5C13.9696 26 13.4609 25.7893 13.0858 25.4142C12.7107 25.0391 12.5 24.5304 12.5 24V16Z",
    fill: "currentColor",
    fillOpacity: 0.32
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFolder2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Folder2.178696c11075b6893c1e729951541909.svg";